import PropTypes from 'prop-types';

export const subcategoryProps = {
  id: PropTypes.number.isRequired,
  displayName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export const subcategory = PropTypes.shape(subcategoryProps);
